const getSelectedRoom = state => state.photoAdminState.selectedRoom;
const isLoading = state => state.photoAdminState.isLoading;
const getLoadingPhotos = state => state.photoAdminState.loadingPhotos;

export default {
  getSelectedRoom,
  isLoading,
  getLoadingPhotos
};
